import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { ResetPasswordModel } from '@hrra/common-models';
import { Store } from '@ngrx/store';
import { resetPassword, clearResetPasswordPageInfo } from 'src/app/root-store/jobseeker-store/reset-password/actions';
import { selectIsResetPasswordLoading, selectIsResetSuccessed, selectPasswordResetViewModel, selectUserRegistrationNotFound } from 'src/app/root-store/jobseeker-store/reset-password/selectors';
import { selectRecaptchaSiteKey } from 'src/app/root-store/selectors';
import { AppState } from 'src/app/root-store/state';

@Component({
    selector: 'app-jobseeker-password-reset',
    templateUrl: './redesign/jobseeker-password-reset.component.html',
    styleUrls: ['./redesign/jobseeker-password-reset.component.scss'],
    standalone: false
})
export class JobseekerPasswordResetComponent implements OnInit {
  private store = inject<Store<AppState>>(Store);

  submitForm = new UntypedFormGroup({
    email: new UntypedFormControl(null, Validators.required),
    recaptcha: new UntypedFormControl(null, Validators.required)
  });

  userRegistrationNotFound = this.store.selectSignal(selectUserRegistrationNotFound);
  isResetSuccessed = this.store.selectSignal(selectIsResetSuccessed);
  isLoading = this.store.selectSignal(selectIsResetPasswordLoading);
  recaptchaSiteKey = this.store.selectSignal(selectRecaptchaSiteKey);
  resetPasswordModel = this.store.selectSignal(selectPasswordResetViewModel);

  ngOnInit(): void {
    this.store.dispatch(clearResetPasswordPageInfo());
  }

  resetPassword(){
    if (this.submitForm.valid){

      let request = <ResetPasswordModel>{
        email: this.submitForm.get('email').value,
        reCaptchaToken: this.submitForm.get('recaptcha').value,
      }

      this.store.dispatch(resetPassword({payload: request}));
    }
  }

  public submitResetPasswordForm(formDirective: FormGroupDirective) {
    if (this.submitForm.valid){
      formDirective.resetForm();
      this.submitForm.reset();
    }
  }
}
